module.exports = __webpack_public_path__ + "app/assets/images/woman11-9502fc4414c89c6e19fca0263b6f76be.jpg";